import { initModal, toggleModal } from '../modal';
const init = () => {
    initModal('uk-popup');
    window.addEventListener('region-country-code-detected', (event) => {
        if ((event.detail.ipDetectedRegionCode === 'UK' || event.detail.ipDetectedRegionCode === 'GB') && !localStorage.getItem('uk_popup_viewed')) {
            const closeButtons = document.querySelectorAll('#uk-popup [data-modal-close]');
            [...closeButtons].forEach((button) => {
                button.addEventListener('click', () => {
                    localStorage.setItem('uk_popup_viewed', '1');
                });
            });
            toggleModal('uk-popup');
        }
    });
    if (Shopify.designMode && window.theme.ukPopupEnabled) {
        toggleModal('uk-popup');
    }
};
export default init;
